import { TbChevronLeft, TbX } from "react-icons/tb";

type Props = {
  title: string;
  isMobile: boolean;
  onBack: () => void;
  onClose: () => void;
};

const AddressModalHeader: React.FC<Props> = ({ title, isMobile, onBack, onClose }) => {
  return (
    <div className={`flex items-center justify-between shrink-0 ${isMobile ? "px-3 pt-3" : "p-3"}`}>
      <button
        onClick={onBack}
        className="flex items-center justify-center w-11 h-11 border-none bg-transparent cursor-pointer shrink-0"
      >
        <TbChevronLeft size={22} color="#333" />
      </button>
      <span className="text-[21px] font-semibold text-black font-poppins">
        {title}
      </span>
      <button
        onClick={onClose}
        className="flex items-center justify-center w-11 h-11 border-none bg-transparent cursor-pointer shrink-0"
      >
        <TbX size={20} color="#333" />
      </button>
    </div>
  );
};

export default AddressModalHeader;
